import React from 'react';
import { reviews } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Reviews = () => {
  return (
    <section className="py-24 bg-[#F9F8F6] border-b border-[#E5E5E5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {reviews.map((review) => (
            <div key={review.id} className="text-center flex flex-col items-center">
              <div className="flex gap-1 mb-6 text-[#8B7355]">
                {[1, 2, 3, 4, 5].map(star => (
                  <SafeIcon key={star} icon={FiIcons.FiStar} className="w-5 h-5 fill-current" />
                ))}
              </div>
              <p className="text-lg text-[#2C2C2C] mb-6 italic leading-relaxed">
                "{review.text}"
              </p>
              <div className="mt-auto">
                <p className="font-medium text-[#2C2C2C]">{review.author}</p>
                <p className="text-sm text-[#737373]">{review.location}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;